import React from "react";
import FavoriteView from "../views/FavoriteView";

const Favorite: React.FC = () => {
    return <div>
        <FavoriteView />
    </div>;
};

export default Favorite;